import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import DatasetExamplesDisplay from "./DatasetExamplesDisplay";

export default Node.create({
  name: "dataset-examples",

  group: "inline",
  inline: true,

  atom: true,
  selectable: false,

  addAttributes() {
    return {
      dataset: {
        default: null,
      },
      version: {
        default: null,
      },
      examples: {
        default: null,
      },
      columns: {
        default: null,
      },
      dataType: {
        default: "json",
      },
      mounted: {
        default: true,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "dataset-examples",
      },
    ];
  },

  renderText(ref) {
    const { dataset, version, examples, columns, dataType } = ref.node.attrs;
    return `«««dataset:${dataset}:${version}:${examples}:${columns}:${dataType}»»»`;
  },

  renderHTML({ HTMLAttributes }) {
    return ["dataset-examples", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(DatasetExamplesDisplay, {
      contentDOMElementTag: "span",
    });
  },
});
